import { FILTER_TYPES } from 'components/FilterPod';
import { REQUEST_STATUS } from '../../constants/consts';

const filters = () => [
  {
    title: 'محدوده تاریخ درخواست',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'requestDate',
    query: {
      start: 'requestFromDate',
      end: 'requestToDate',
    },
    id: {
      start: 1, // fake
      end: 2, // fake
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {},
      end: {},
    },
  },
  {
    title: 'محدوده تاریخ تعیین وضعیت',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'determineDate',
    query: {
      start: 'determineFromDate',
      end: 'determineToDate',
    },
    id: {
      start: 3, // fake
      end: 4, // fake
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {},
      end: {},
    },
  },
  {
    title: 'شناسه درخواست',
    label: 'شناسه',
    keyName: 'requestId',
    query: 'requestId',
    id: 5, // fake
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {
      dir: 'ltr',
      englishNumber: true,
    },
  },
  {
    title: 'وضعیت',
    label: 'وضعیت',
    keyName: 'status',
    query: 'status',
    id: 6, // fake
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: [...REQUEST_STATUS],
    },
  },
];

export default filters;
